import ResponseBaseModel from '../../ResponseBaseModel'

export default class CACA1070ResponseModel extends ResponseBaseModel {
  productNameInformal: string
  operatProductPdfInfoLst: [
    {
      operatProductPdfName: string
      operatProductPdfLnkUrl: string
    }
  ]

  operatProductMaterialInfo: {
    operatProductMaterialInfoPdfName: string
    operatProductMaterialInfoPdfLnkUrl: string
  }

  operatProductProspectusPdfInfoLst: [
    {
      operatProductProspectusPdfName: string
      operatProductProspectusPdfLnkUrl: string
    }
  ]

  operatProductInvestmentRpPdfInfoLst: [
    {
      operatProductInvestmentRpPdfName: string
      operatProductInvestmentRpPdfLnkUrl: string
      docTypeId: string
      settlementTerm: string
      settlementDate: string
    }
  ]

  productDivName: string
}
